(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var revealObserver = null;
  var lastFocusedElement = null;
  var cartRequestId = 0;

  function query(selector, root) {
    return (root || document).querySelector(selector);
  }

  function queryAll(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function getThemeRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    if (window.themeRoutes && window.themeRoutes.root) {
      return window.themeRoutes.root;
    }

    return "/";
  }

  function getRoute(name, fallback) {
    if (window.themeRoutes && window.themeRoutes[name]) {
      return window.themeRoutes[name];
    }

    return getThemeRoot() + fallback.replace(/^\//, "");
  }

  function isWholesaleCustomer() {
    if (typeof window.isWsgCustomer === "undefined") return false;

    return window.isWsgCustomer === true ||
      window.isWsgCustomer === 1 ||
      window.isWsgCustomer === "true";
  }

  function escapeHtml(value) {
    var element = document.createElement("div");
    element.textContent = value == null ? "" : String(value);
    return element.innerHTML;
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === "function" && window.themeSettings) {
      return window.Shopify.formatMoney(amount, window.themeSettings.moneyFormat);
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "it-IT", {
        style: "currency",
        currency: window.themeSettings && window.themeSettings.currency
          ? window.themeSettings.currency
          : "EUR"
      }).format(amount / 100);
    } catch (error) {
      return "€" + (amount / 100).toFixed(2).replace(".", ",");
    }
  }

  function resizedImageUrl(source, width) {
    if (!source) return "";

    try {
      var url = new URL(source, window.location.origin);
      url.searchParams.set("width", String(width));
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function initReveals(root) {
    var elements = queryAll("[data-reveal]:not(.is-visible)", root || document);
    if (!elements.length) return;

    if (reduceMotion || !("IntersectionObserver" in window)) {
      elements.forEach(function (element) {
        element.classList.add("is-visible");
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        });
      }, {
        threshold: 0.08,
        rootMargin: "0px 0px -5% 0px"
      });
    }

    elements.forEach(function (element) {
      revealObserver.observe(element);
    });
  }

  function initMarquees(root) {
    queryAll(".marquee__track", root || document).forEach(function (track) {
      if (track.dataset.marqueeReady === "true") return;
      track.dataset.marqueeReady = "true";
      track.insertAdjacentHTML("beforeend", track.innerHTML);
    });
  }

  function openCart() {
    var drawer = query("[data-cart-drawer]");
    if (!drawer) return;

    lastFocusedElement = document.activeElement;
    document.body.classList.add("cart-open");
    drawer.setAttribute("aria-hidden", "false");

    window.requestAnimationFrame(function () {
      var closeButton = query("[data-cart-close-button]", drawer);
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  }

  function closeCart() {
    var drawer = query("[data-cart-drawer]");
    document.body.classList.remove("cart-open");

    if (drawer) drawer.setAttribute("aria-hidden", "true");

    if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
      lastFocusedElement.focus({ preventScroll: true });
    }
  }

  function updateCartCount(count) {
    queryAll("[data-cart-count], [data-ph-cart-count]").forEach(function (element) {
      element.textContent = String(count || 0);

      if (element.hasAttribute("data-cart-count")) {
        element.hidden = false;
      }
    });
  }

  function visibleProperties(properties) {
    if (!properties) return "";

    return Object.keys(properties)
      .filter(function (key) {
        return key.charAt(0) !== "_" && properties[key];
      })
      .map(function (key) {
        return "<span>" + escapeHtml(key) + ": " + escapeHtml(properties[key]) + "</span>";
      })
      .join("");
  }

  function renderCart(cart) {
    var itemsElement = query("[data-cart-items]");
    var subtotalElement = query("[data-cart-subtotal]");
    var footerElement = query("[data-cart-foot]");

    updateCartCount(cart.item_count);
    if (!itemsElement) return cart;

    if (!cart.item_count) {
      itemsElement.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<p class="font-display">Il carrello è vuoto</p>' +
          '<span>Aggiungi le tue fragranze preferite.</span>' +
        "</div>";

      if (footerElement) footerElement.hidden = true;
      return cart;
    }

    if (footerElement) footerElement.hidden = false;

    itemsElement.innerHTML = cart.items.map(function (item) {
      var rule = item.quantity_rule || {};
      var minimum = Math.max(1, Number(rule.min || 1));
      var increment = Math.max(1, Number(rule.increment || 1));
      var maximum = rule.max == null ? "" : Number(rule.max);
      var variantTitle = item.variant_title && item.variant_title !== "Default Title"
        ? '<span class="cart-line__variant">' + escapeHtml(item.variant_title) + "</span>"
        : "";
      var properties = visibleProperties(item.properties);
      var image = resizedImageUrl(item.image || (item.featured_image && item.featured_image.url), 220);
      var title = escapeHtml(item.product_title || item.title);
      var linePrice = item.final_line_price != null ? item.final_line_price : item.final_price * item.quantity;

      return (
        '<article class="cart-line" data-cart-line data-line-key="' + escapeHtml(item.key) + '">' +
          '<a class="cart-line__image" href="' + escapeHtml(item.url || "#") + '">' +
            (image
              ? '<img src="' + escapeHtml(image) + '" alt="' + title + '" width="110" height="132" loading="lazy">'
              : '<span class="cart-line__image-placeholder"></span>') +
          "</a>" +
          '<div class="cart-line__content">' +
            '<div class="cart-line__top">' +
              '<div>' +
                '<a class="cart-line__title font-display" href="' + escapeHtml(item.url || "#") + '">' + title + "</a>" +
                variantTitle +
                (properties ? '<div class="cart-line__properties">' + properties + "</div>" : "") +
              "</div>" +
              '<button type="button" class="cart-line__remove" data-cart-remove="' + escapeHtml(item.key) + '" aria-label="Rimuovi ' + title + '">×</button>' +
            "</div>" +
            '<strong class="cart-line__price font-mono">' + formatMoney(linePrice) + "</strong>" +
            '<div class="qty cart-line__quantity">' +
              '<button type="button" data-cart-quantity-down="' + escapeHtml(item.key) + '" data-min="' + minimum + '" data-increment="' + increment + '" aria-label="Diminuisci quantità">−</button>' +
              '<input value="' + Number(item.quantity || 1) + '" min="' + minimum + '" step="' + increment + '"' + (maximum !== "" ? ' max="' + maximum + '"' : "") + ' readonly aria-label="Quantità">' +
              '<button type="button" data-cart-quantity-up="' + escapeHtml(item.key) + '" data-max="' + maximum + '" data-increment="' + increment + '" aria-label="Aumenta quantità">+</button>' +
            "</div>" +
          "</div>" +
          '<span class="cart-line__loader" aria-hidden="true"></span>' +
        "</article>"
      );
    }).join("");

    if (subtotalElement) subtotalElement.textContent = formatMoney(cart.total_price);
    return cart;
  }

  function parseJsonResponse(response) {
    return response.text().then(function (text) {
      var data = {};

      try {
        data = text ? JSON.parse(text) : {};
      } catch (error) {
        if (!response.ok) {
          throw new Error("Si è verificato un errore durante l’aggiornamento del carrello.");
        }
      }

      if (!response.ok) {
        throw new Error(data.description || data.message || "Operazione non riuscita.");
      }

      return data;
    });
  }

  function getCart() {
    var requestId = ++cartRequestId;
    var separator = getRoute("cartJsonUrl", "cart.js").indexOf("?") === -1 ? "?" : "&";

    return fetch(getRoute("cartJsonUrl", "cart.js") + separator + "_=" + Date.now(), {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json"
      },
      cache: "no-store"
    })
      .then(parseJsonResponse)
      .then(function (cart) {
        if (requestId === cartRequestId) renderCart(cart);
        return cart;
      });
  }

  function setCartLineLoading(key, loading) {
    queryAll("[data-cart-line]").forEach(function (line) {
      if (line.getAttribute("data-line-key") === key) {
        line.classList.toggle("is-loading", loading);
      }
    });
  }

  function changeCartLine(key, quantity) {
    setCartLineLoading(key, true);

    return fetch(getRoute("cartChangeUrl", "cart/change.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(0, Number(quantity || 0))
      })
    })
      .then(parseJsonResponse)
      .then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
        return cart;
      })
      .catch(function (error) {
        window.alert(error.message);
        return getCart();
      })
      .finally(function () {
        setCartLineLoading(key, false);
      });
  }

  function showFormError(form, message) {
    var wrapper = form.closest("[data-ajax-product-form]");
    var errorElement = wrapper ? query("[data-product-form-error]", wrapper) : null;

    if (errorElement) {
      errorElement.textContent = message;
      errorElement.hidden = false;
    } else {
      window.alert(message);
    }
  }

  function clearFormError(form) {
    var wrapper = form.closest("[data-ajax-product-form]");
    var errorElement = wrapper ? query("[data-product-form-error]", wrapper) : null;

    if (errorElement) {
      errorElement.textContent = "";
      errorElement.hidden = true;
    }
  }

  function setSubmitLoading(form, loading) {
    queryAll("[type='submit'][name='add'], [data-product-submit]", form).forEach(function (button) {
      if (loading) {
        button.dataset.wasDisabled = button.disabled ? "true" : "false";
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
      } else {
        button.disabled = button.dataset.wasDisabled === "true";
        button.removeAttribute("aria-busy");
        delete button.dataset.wasDisabled;
      }
    });
  }

  function normaliseQuantity(input) {
    if (!input) return 1;

    var minimum = Math.max(1, parseInt(input.min, 10) || 1);
    var increment = Math.max(1, parseInt(input.step, 10) || 1);
    var maximum = input.max ? parseInt(input.max, 10) : null;
    var value = parseInt(input.value, 10);

    if (!Number.isFinite(value)) value = minimum;
    value = Math.max(minimum, value);

    var offset = value - minimum;
    value = minimum + Math.round(offset / increment) * increment;

    if (maximum !== null && Number.isFinite(maximum)) {
      value = Math.min(maximum, value);
    }

    input.value = String(value);
    return value;
  }

  function addProductForm(form) {
    clearFormError(form);
    normaliseQuantity(query("[name='quantity']", form));
    setSubmitLoading(form, true);

    var formData = new FormData(form);

    return fetch(getRoute("cartAddUrl", "cart/add.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json"
      },
      body: formData
    })
      .then(parseJsonResponse)
      .then(function (addedItem) {
        return getCart().then(function (cart) {
          document.dispatchEvent(new CustomEvent("cart:updated", {
            detail: {
              cart: cart,
              addedItem: addedItem
            }
          }));
          openCart();
          return cart;
        });
      })
      .catch(function (error) {
        showFormError(form, error.message);
        throw error;
      })
      .finally(function () {
        setSubmitLoading(form, false);
      });
  }

  function setGalleryIndex(gallery, index) {
    if (!gallery) return;

    var slides = queryAll("[data-product-media-slide]", gallery);
    if (!slides.length) return;

    var nextIndex = ((Number(index) % slides.length) + slides.length) % slides.length;
    var track = query("[data-product-gallery-track]", gallery);

    gallery.dataset.activeIndex = String(nextIndex);
    if (track) track.style.transform = "translate3d(-" + nextIndex * 100 + "%,0,0)";

    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === nextIndex;
      slide.setAttribute("aria-hidden", active ? "false" : "true");

      if (!active) {
        queryAll("video", slide).forEach(function (video) {
          if (typeof video.pause === "function") video.pause();
        });
      }
    });

    queryAll("[data-product-gallery-thumbnail]", gallery).forEach(function (thumbnail) {
      var active = Number(thumbnail.dataset.mediaIndex) === nextIndex;
      thumbnail.classList.toggle("is-active", active);
      thumbnail.setAttribute("aria-current", active ? "true" : "false");

      if (active && thumbnail.parentElement) {
        var thumbnailScroller = thumbnail.parentElement;
        var targetLeft = thumbnail.offsetLeft - (thumbnailScroller.clientWidth - thumbnail.offsetWidth) / 2;

        if (typeof thumbnailScroller.scrollTo === "function") {
          thumbnailScroller.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: reduceMotion ? "auto" : "smooth"
          });
        } else {
          thumbnailScroller.scrollLeft = Math.max(0, targetLeft);
        }
      }
    });

    var counter = query("[data-product-gallery-current]", gallery);
    if (counter) counter.textContent = String(nextIndex + 1);
  }

  function setGalleryMedia(root, mediaId) {
    if (!mediaId) return;

    var gallery = query("[data-product-gallery]", root);
    if (!gallery) return;

    var slide = query('[data-product-media-slide][data-media-id="' + String(mediaId) + '"]', gallery);
    if (slide) setGalleryIndex(gallery, Number(slide.dataset.mediaIndex));
  }

  function updateQuantityRules(root, option) {
    var input = query("[data-pdp-qty]", root);
    if (!input || !option) return;

    var minimum = Math.max(1, parseInt(option.dataset.min, 10) || 1);
    var increment = Math.max(1, parseInt(option.dataset.increment, 10) || 1);
    var maximum = option.dataset.max ? parseInt(option.dataset.max, 10) : null;

    input.min = String(minimum);
    input.step = String(increment);
    input.value = String(minimum);

    if (maximum !== null && Number.isFinite(maximum)) {
      input.max = String(maximum);
    } else {
      input.removeAttribute("max");
    }

    var rules = query("[data-product-quantity-rules]", root);
    if (!rules) return;

    var minRule = query("[data-product-rule-min]", rules);
    var incrementRule = query("[data-product-rule-increment]", rules);
    var maxRule = query("[data-product-rule-max]", rules);

    if (minRule) {
      minRule.hidden = minimum <= 1;
      var minValue = query("strong", minRule);
      if (minValue) minValue.textContent = String(minimum);
    }

    if (incrementRule) {
      incrementRule.hidden = increment <= 1;
      var incrementValue = query("strong", incrementRule);
      if (incrementValue) incrementValue.textContent = String(increment);
    }

    if (maxRule) {
      maxRule.hidden = maximum === null || !Number.isFinite(maximum);
      var maxValue = query("strong", maxRule);
      if (maxValue && maximum !== null) maxValue.textContent = String(maximum);
    }

    rules.hidden = minimum <= 1 && increment <= 1 && (maximum === null || !Number.isFinite(maximum));
  }

  function updateVariant(root, select) {
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var form = select.closest("form");
    var hiddenInput = form ? query("[data-product-variant-input]", form) : null;
    var submitButton = form ? query("[data-product-submit]", form) : null;
    var submitLabel = submitButton ? query("[data-product-submit-label]", submitButton) : null;
    var available = option.dataset.available === "true";

    if (hiddenInput) {
      hiddenInput.value = option.value;
      hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    setGalleryMedia(root, option.dataset.mediaId);

    if (!isWholesaleCustomer()) {
      var currentPrice = query("[data-product-current-price]", root);
      var comparePrice = query("[data-product-compare-price]", root);
      var discount = query("[data-product-discount]", root);
      var sku = query("[data-product-sku]", root);
      var skuRow = query("[data-product-sku-row]", root);
      var discountValue = parseInt(option.dataset.discount, 10) || 0;

      if (currentPrice) currentPrice.textContent = option.dataset.price || "";

      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || "";
        comparePrice.hidden = discountValue <= 0;
      }

      if (discount) {
        discount.textContent = "-" + discountValue + "%";
        discount.hidden = discountValue <= 0;
      }

      if (submitButton) submitButton.disabled = !available;
      if (submitLabel) {
        submitLabel.textContent = available
          ? submitButton.dataset.addLabel
          : submitButton.dataset.soldOutLabel;
      }

      if (sku) sku.textContent = option.dataset.sku || "";
      if (skuRow) skuRow.hidden = !option.dataset.sku;

      updateQuantityRules(root, option);

      queryAll("[data-product-volume-list]", root).forEach(function (list) {
        list.hidden = list.getAttribute("data-product-volume-list") !== option.value;
      });
    }

    if (!(window.Shopify && window.Shopify.designMode) && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", option.value);
      window.history.replaceState({}, "", url.toString());
    }
  }

  document.addEventListener("click", function (event) {
    var faqButton = event.target.closest(".faq-q");
    if (faqButton) {
      var faqItem = faqButton.closest(".faq-item");
      if (faqItem) faqItem.classList.toggle("is-open");
    }

    var cartToggle = event.target.closest("[data-cart-toggle]");
    if (cartToggle) {
      if (isWholesaleCustomer()) return;
      event.preventDefault();
      getCart()
        .catch(function (error) {
          console.warn("Unable to refresh cart:", error);
        })
        .finally(openCart);
      return;
    }

    if (event.target.closest("[data-cart-close]")) {
      event.preventDefault();
      closeCart();
      return;
    }

    var removeButton = event.target.closest("[data-cart-remove]");
    if (removeButton) {
      event.preventDefault();
      changeCartLine(removeButton.getAttribute("data-cart-remove"), 0);
      return;
    }

    var cartIncrease = event.target.closest("[data-cart-quantity-up]");
    if (cartIncrease) {
      event.preventDefault();
      var increaseInput = cartIncrease.previousElementSibling;
      var increaseStep = Math.max(1, parseInt(cartIncrease.dataset.increment, 10) || 1);
      var increaseMaximum = cartIncrease.dataset.max ? parseInt(cartIncrease.dataset.max, 10) : null;
      var increaseQuantity = (parseInt(increaseInput.value, 10) || 0) + increaseStep;

      if (increaseMaximum !== null && Number.isFinite(increaseMaximum)) {
        increaseQuantity = Math.min(increaseMaximum, increaseQuantity);
      }

      changeCartLine(cartIncrease.getAttribute("data-cart-quantity-up"), increaseQuantity);
      return;
    }

    var cartDecrease = event.target.closest("[data-cart-quantity-down]");
    if (cartDecrease) {
      event.preventDefault();
      var decreaseInput = cartDecrease.nextElementSibling;
      var decreaseStep = Math.max(1, parseInt(cartDecrease.dataset.increment, 10) || 1);
      var decreaseMinimum = Math.max(1, parseInt(cartDecrease.dataset.min, 10) || 1);
      var decreaseQuantity = (parseInt(decreaseInput.value, 10) || decreaseMinimum) - decreaseStep;

      if (decreaseQuantity < decreaseMinimum) decreaseQuantity = 0;
      changeCartLine(cartDecrease.getAttribute("data-cart-quantity-down"), decreaseQuantity);
      return;
    }

    var quantityIncrease = event.target.closest("[data-pdp-qty-up]");
    var quantityDecrease = event.target.closest("[data-pdp-qty-down]");

    if (quantityIncrease || quantityDecrease) {
      event.preventDefault();
      var quantityContainer = (quantityIncrease || quantityDecrease).closest("form, [data-product-main]");
      var quantityInput = quantityContainer ? query("[data-pdp-qty]", quantityContainer) : null;
      if (!quantityInput) return;

      var minimum = Math.max(1, parseInt(quantityInput.min, 10) || 1);
      var increment = Math.max(1, parseInt(quantityInput.step, 10) || 1);
      var maximum = quantityInput.max ? parseInt(quantityInput.max, 10) : null;
      var current = parseInt(quantityInput.value, 10) || minimum;
      var next = quantityIncrease ? current + increment : Math.max(minimum, current - increment);

      if (maximum !== null && Number.isFinite(maximum)) next = Math.min(maximum, next);
      quantityInput.value = String(next);
      quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    var previousGallery = event.target.closest("[data-product-gallery-previous]");
    var nextGallery = event.target.closest("[data-product-gallery-next]");
    var thumbnail = event.target.closest("[data-product-gallery-thumbnail]");

    if (previousGallery || nextGallery || thumbnail) {
      event.preventDefault();
      var gallery = (previousGallery || nextGallery || thumbnail).closest("[data-product-gallery]");
      var activeIndex = Number(gallery.dataset.activeIndex || 0);

      if (thumbnail) {
        setGalleryIndex(gallery, Number(thumbnail.dataset.mediaIndex));
      } else {
        setGalleryIndex(gallery, activeIndex + (nextGallery ? 1 : -1));
      }
    }
  });

  document.addEventListener("change", function (event) {
    var quantityInput = event.target.closest("[data-pdp-qty]");
    if (quantityInput) normaliseQuantity(quantityInput);

    var variantSelect = event.target.closest("[data-product-variant-select]");
    if (variantSelect) {
      var root = variantSelect.closest("[data-product-main]");
      if (root) updateVariant(root, variantSelect);
    }
  });

  document.addEventListener("blur", function (event) {
    if (event.target.matches && event.target.matches("[data-pdp-qty]")) {
      normaliseQuantity(event.target);
    }
  }, true);

  /*
   * Carrello unificato D2C/B2B
   * I form prodotto usano sempre il submit nativo Shopify. In questo modo
   * Wholesale Gorilla può conservare quantità, regole e dati B2B senza che
   * il drawer AJAX del tema crei un secondo flusso carrello.
   */

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && document.body.classList.contains("cart-open")) {
      closeCart();
    }
  });

  var pointerStart = null;

  document.addEventListener("pointerdown", function (event) {
    var viewport = event.target.closest(".product-gallery__viewport");
    if (!viewport || event.pointerType === "mouse") return;

    pointerStart = {
      x: event.clientX,
      y: event.clientY,
      gallery: viewport.closest("[data-product-gallery]")
    };
  }, { passive: true });

  document.addEventListener("pointerup", function (event) {
    if (!pointerStart || !pointerStart.gallery) return;

    var differenceX = event.clientX - pointerStart.x;
    var differenceY = event.clientY - pointerStart.y;
    var gallery = pointerStart.gallery;
    pointerStart = null;

    if (Math.abs(differenceX) < 45 || Math.abs(differenceX) < Math.abs(differenceY)) return;

    var activeIndex = Number(gallery.dataset.activeIndex || 0);
    setGalleryIndex(gallery, activeIndex + (differenceX < 0 ? 1 : -1));
  }, { passive: true });

  document.addEventListener("shopify:section:load", function (event) {
    initReveals(event.target);
    initMarquees(event.target);

    queryAll("[data-product-gallery]", event.target).forEach(function (gallery) {
      setGalleryIndex(gallery, Number(gallery.dataset.activeIndex || 0));
    });
  });

  initReveals(document);
  initMarquees(document);

  queryAll("[data-product-gallery]").forEach(function (gallery) {
    setGalleryIndex(gallery, Number(gallery.dataset.activeIndex || 0));
  });

  getCart().catch(function (error) {
    console.warn("Cart initialization failed:", error);
  });
})();
